import { BaseType } from '../../base/base-type';
import { FinancialInstitutionEnum } from '../../enum/shared/financial-institution-enum';

export class FinancialInstitutionType extends BaseType {
  public declare id: FinancialInstitutionEnum;
  public institutionNumber!: string | null;
}
